import { createContext} from 'react';

const LabIDContext = createContext("");

export default LabIDContext;
